import { render, staticRenderFns } from "./setCoverImg.vue?vue&type=template&id=92377cf0&"
import script from "./setCoverImg.vue?vue&type=script&lang=js&"
export * from "./setCoverImg.vue?vue&type=script&lang=js&"
import style0 from "./setCoverImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports